<template>
  <b-modal
    id="changing-branch-prompt"
    centered
    title="Change Branch">
    <p class="text-center">Please empty your cart before changing branch.</p>
    <template slot="modal-footer">
      <b-button @click="closeModal" variant="primary">Okay</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      cartItems: "conversationalCommerce/cartItems"
    })
  },
  methods: {
    closeModal() {
      this.$root.$emit("bv::hide::modal", "changing-branch-prompt");
    },
    proceedChangeBranch() {
      const itemUuids = this.cartItems.list
        .map(list => list.items)
        .flat()
        .map(item => item.uuid);
      console.log('remove items', itemUuids);
    }
  }
}
</script>
